import {useMemo} from "react";
import {useTranslation} from "react-i18next";

export default function Button({ children, className, style, onClick = () => null, loading, disabled }) {
  const { t } = useTranslation();
  
  const _disabled = useMemo(() => {
    return disabled || loading || false;
  }, [disabled, loading]);
  
  return (
    <button className={`${className ? className : 'px-[10px] py-[5px] bg-[#eece7a] rounded-[99px] text-[14px]'} ${disabled ? ' cursor-not-allowed' : 'cursor-pointer'}`}
            disabled={_disabled}
            onClick={onClick}
            style={{ opacity: _disabled ? 0.85 : 1, ...style }}>
      {
        !loading
          ? children
          : t('加载中...')
        // : <i className="relative top-[-1px] iconfont inline-block icon-loading btnLoadingAnimate text-white text-[14px]"></i>
      }
    </button>
  );
}
